import React, { useCallback, useContext, useEffect, useState } from "react";
import { DarkModeContext } from "../../context/DarkModeContext";
import { getToken } from "../../utils/auth";
import AnticiposExcepciones from "./AnticiposExcepciones";
import CentroLiquidaciones from "./CentroLiquidaciones";
import CondicionesFinancieras from "./CondicionesFinancieras";
import ConfiguracionOperativa from "./ConfiguracionOperativa";
import FurAutonomo from "./FurAutonomo";
import LiquidacionArchivos from "./LiquidacionArchivos";
import LiquidacionGuiada from "./LiquidacionGuiada";
import LiquidacionesRegistradas from "./LiquidacionesRegistradas";
import ProcesamientoSas from "./ProcesamientoSas";
import VistaEjecutiva from "./VistaEjecutiva";
import { pagosApi } from "./pagosApi";
import "./pagos.css";

const PESTANAS = [
  { key: "procesamiento", label: "Procesamiento" },
  { key: "condiciones", label: "Condiciones financieras" },
  { key: "fur-autonomo", label: "FUR autónomo — Simulación" },
  { key: "archivos", label: "Liquidación desde archivos" },
  { key: "anticipos", label: "Anticipos y excepciones" },
];

export default function Pagos() {
  const { darkMode } = useContext(DarkModeContext);
  const token = getToken();
  const [persistencia, setPersistencia] = useState(null);
  const [resumen, setResumen] = useState(null);
  const [errorResumen, setErrorResumen] = useState("");
  const [cargandoResumen, setCargandoResumen] = useState(false);
  const [seccion, setSeccion] = useState("centro");
  const [seleccion, setSeleccion] = useState(null);
  const [registros, setRegistros] = useState(0);
  const [pestana, setPestana] = useState("procesamiento");

  const cargarCentro = useCallback(async () => {
    setCargandoResumen(true); setErrorResumen("");
    try { setResumen(await pagosApi.centroLiquidaciones(token)); }
    catch (error) { setErrorResumen(error?.message || "No se pudo cargar el resumen de liquidaciones."); }
    finally { setCargandoResumen(false); }
  }, [token]);

  useEffect(() => {
    let vigente = true;
    Promise.resolve().then(() => pagosApi.estadoLiquidaciones(token))
      .then((estado) => { if (vigente) setPersistencia(estado || { habilitada: false }); })
      .catch((error) => { if (vigente) setPersistencia({ habilitada: false, motivo: error?.message || "Persistencia no disponible." }); });
    return () => { vigente = false; };
  }, [token]);

  useEffect(() => { if (persistencia?.habilitada) cargarCentro(); }, [persistencia, cargarCentro, registros]);

  const abrir = (item) => { setSeleccion({ corridaId: item.id, fecha: String(item.fechaPago).slice(0, 10) }); setSeccion("liquidacion"); };
  const nueva = () => { setSeleccion(null); setSeccion("liquidacion"); };

  return <main className={`pagos-page${darkMode ? " pagos-page--dark" : ""}`} data-testid="pagos-page">
    <header className="pagos-header pagos-hero">
      <div><p className="pagos-eyebrow">Zoco Pagos</p><h1>Centro de liquidaciones</h1>
        <p className="pagos-subtitle">Procesá, conciliá y revisá cada liquidación desde un único lugar, con trazabilidad completa y controles antes de cualquier aprobación.</p></div>
      <div className="pagos-header-badges"><span className="pagos-mode-badge">Simulación · solo lectura productiva</span>
        <span className="pagos-status pagos-status--pending">Pendiente de validación</span></div>
    </header>

    <nav className="pagos-main-nav" aria-label="Secciones de liquidaciones">
      <button type="button" className={seccion === "centro" ? "is-active" : ""} onClick={() => setSeccion("centro")}>Resumen</button>
      <button type="button" className={seccion === "liquidacion" ? "is-active" : ""} onClick={nueva}>Nueva liquidación</button>
      <button type="button" className={seccion === "configuracion" ? "is-active" : ""} onClick={() => setSeccion("configuracion")}>Decisiones y homologación</button>
      <button type="button" className={seccion === "ejecutiva" ? "is-active" : ""} onClick={() => setSeccion("ejecutiva")}>Vista ejecutiva</button>
    </nav>

    {seccion === "centro" && <CentroLiquidaciones resumen={resumen} loading={cargandoResumen} error={errorResumen} onNueva={nueva} onAbrir={abrir} onActualizar={cargarCentro} />}
    {seccion === "liquidacion" && <LiquidacionGuiada token={token} corridaInicial={seleccion} onActualizada={() => setRegistros((value) => value + 1)} />}
    {seccion === "configuracion" && <ConfiguracionOperativa token={token} persistencia={persistencia} />}
    {seccion === "ejecutiva" && <VistaEjecutiva resumen={resumen} />}

    <details className="pagos-advanced-tools">
      <summary>Herramientas avanzadas <small>Consulta técnica para usuarios autorizados</small></summary>
      <div className="pagos-tabs" role="tablist" aria-label="Herramientas avanzadas de Pagos">{PESTANAS.map((item) => <button key={item.key} type="button" role="tab" aria-selected={pestana === item.key} className={pestana === item.key ? "is-active" : ""} onClick={() => setPestana(item.key)}>{item.label}</button>)}</div>
      {pestana === "procesamiento" ? <><ProcesamientoSas token={token} persistencia={persistencia} onRegistered={() => setRegistros((value) => value + 1)} /><LiquidacionesRegistradas token={token} persistencia={persistencia} refreshKey={registros} /></>
        : pestana === "condiciones" ? <CondicionesFinancieras token={token} />
          : pestana === "fur-autonomo" ? <FurAutonomo token={token} />
            : pestana === "archivos" ? <LiquidacionArchivos token={token} /> : <AnticiposExcepciones token={token} />}
    </details>
  </main>;
}
